import { type FunctionComponent } from 'react';
import { animated } from '@react-spring/web';

import { type AxisTickProps } from '@nivo/axes';
import moment from 'moment-timezone';
import { Timestamp } from '../../../services/Timestamp';

interface Props {
  tickProps: AxisTickProps<Date>;
  timezone: string;
}

const SpeedChartAxisBottomTick: FunctionComponent<Props> = ({ tickProps, timezone }) => {
  const { animatedProps, textBaseline, textAnchor, value } = tickProps;
  const dateTimeOffset = Timestamp.fromMilliseconds(moment.utc(value).valueOf()).toLocationDateTimeOffset(timezone);
  return (
    <animated.g transform={animatedProps.transform} opacity={animatedProps.opacity}>
      <animated.text
        className="text-xs-regular bottom-axis-label"
        dominantBaseline={textBaseline as never}
        textAnchor={textAnchor as never}
        transform={animatedProps.textTransform}
      >
        {dateTimeOffset.format('HH:mm')}
      </animated.text>
    </animated.g>
  );
};

export default SpeedChartAxisBottomTick;
